export function forcedPopup() {
  const popup = document.getElementById("forced-popup");
  if (!popup) return;

  setTimeout(() => {
    popup.classList.add("is-open");
    popup.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
  }, 2000);

  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape" && popup.classList.contains("is-open")) {
      ev.preventDefault();
    }
  });
}
